import Vue from 'vue'
import App from './App.vue'
import router from './router'
import RymApp from '@/utils/native'
import { isPrdEnv, initH5TrackSdk, loadScript } from '@/utils'


Vue.config.productionTip = false

function createApp () {
  new Vue({
    router,
    render: h => h(App)
  }).$mount('#app')
}


const h5TrackSdkUrl = isPrdEnv() ? "https://iobs02.pingan.com.cn/download/eits-access-dmz-prd/h5sdk_s_3.0.0.js" : "https://iobs02.pingan.com.cn/download/eits-access-dmz-prd/h5sdk_test_3.0.0.js";


if (RymApp.IS_ANYDOOR) {
  createApp()
} else {
  initH5TrackSdk()
  Promise.all([
    loadScript('https://res.wx.qq.com/open/js/jweixin-1.4.0.js'),
    loadScript(h5TrackSdkUrl)
  ]).then(() => {
    createApp()
  })
}
